import { motion, useReducedMotion } from "framer-motion";
import { PHILOSOPHY } from "@/lib/siteConfig";

/**
 * Renders the program philosophy as an editorial-style numbered list.
 */
export default function PhilosophyList({ testid = "philosophy-list" }) {
  const reduced = useReducedMotion();
  return (
    <ul data-testid={testid} className="space-y-5">
      {PHILOSOPHY.map((line, i) => (
        <motion.li
          key={line}
          initial={reduced ? false : { opacity: 0, y: 8 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.45, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
          className="flex gap-4 sm:gap-5"
        >
          <span className="font-display text-2xl sm:text-3xl text-terracotta leading-none w-9 sm:w-10 shrink-0 mt-1">
            {String(i + 1).padStart(2, "0")}
          </span>
          <p className="font-display text-lg sm:text-xl text-ink leading-[1.45]">
            {line}
          </p>
        </motion.li>
      ))}
    </ul>
  );
}
